import { setURL } from '@/api/apiUtil'

export default {
  // 修改場域平面圖
  updateFloorPlanByFloorId: {
    url: (floorId) =>
      setURL('/floor/:floorId/floor-plan', { floorId }),
    method: 'put'
  },
  // 根據樓層編號取得樓層資訊
  getFloorInfoByFloorId: {
    url: (floorId) =>
      setURL('/floor/info/:floorId', { floorId }),
    method: 'get'
  },
  // 以下存取groupDataStore，使用在平面圖
  // 新增groupDataStore
  setGroupDataStore: {
    url: (groupId, dataName) =>
      setURL('/WebAPI/api/GroupDataStore/set/:groupId/:dataName', 
        { 
          groupId,
          dataName
        }, true),
    method: 'post'
  },
  // 取得groupDataStore
  listGroupDataStore: {
    url: (groupId, dataName) =>
      setURL('/WebAPI/api/GroupDataStore/list/:groupId/:dataName', 
        {
          groupId,
          dataName
        }, true),
    method: 'get'
  },
  // 刪除groupDataStore
  delGroupDataStore: {
    url: (groupId, dataName, dataKey) =>
      setURL('/WebAPI/api/GroupDataStore/del/:groupId/:dataName/:dataKey', 
        {
          groupId,
          dataName,
          dataKey
        }, true),
    method: 'delete'
  },
  // 修改groupDataStore
  updateGroupDataStore: {
    url: (groupId, dataName) =>
      setURL('/WebAPI/api/GroupDataStore/update/:groupId/:dataName', 
        {
          groupId,
          dataName
        }, true),
    method: 'put'
  },


}
